import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager'
import { Link } from 'react-router-dom';
export class Success extends Component {
    static displayName = Success.name;
    constructor(props) {
        super(props);
        this.state = {
            responseData: null,
        };
        this.SuccessRef = React.createRef();
        this.billingKey = "";
    }

    componentDidMount() {
        this.confirm();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchParams !== this.props.searchParams) {
            this.confirm();
        }
    }

    async confirm() {
        const urlParams = new URLSearchParams(window.location.search);

        const billingKey = urlParams.get("billingKey");
        const code = urlParams.get("code");
        const message = urlParams.get("message");
        if (code) {
            window.location.href = window.location.origin + `/Fail?message=${message}`;
        }
        else {
            let Data = await Big3Common.Post("api/Common/Common/RegisterBillingKey", {
                bill_key: billingKey
            }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
            } else {
                window.location.href = window.location.origin + '/Fail?message=빌링키 등록에 실패했습니다.';
            }
        }
        

    }

    render() {
        return (
            <>
                <div className="box_section">
                    <img width="100px" src="https://static.toss.im/illusts/check-blue-spot-ending-frame.png" alt="성공 이미지" />
                    <h2>카드등록을 완료했습니다.</h2>
                    <Link to="/MyPage/MyInfoMgr/Index"
                        style={{ marginTop: "30px" }}
                    >
                        <button className="payment-button">확인</button>
                    </Link>
                </div>
                
            </>
        );
    }
}
